<div class="w-100 w-100 bg-white-100 container-fluid row row-cols-2 pt-5"
     style="background-color: #f9fafc; margin: 0; padding: 10px; height: 95vh">
  <div *ngIf="!(afAuth.user | async)" class="alert alert-warning">
    You must be signed in to submit this form. Please <a href="/landing">sign in</a>.
  </div>
  <div class="col-3 project-section vh-100">
    <app-project-form-nav
      #nav
      (stepToggled)="toggleStep($event)"
      [formData]="formData">
    </app-project-form-nav>
  </div>

  <div class="col-9 project-section" style="padding: 0 20px 0 20px;">
    <div class="row row-cols-1 gap-2">
      <div
        style="background-color: #FFFFFF; border-radius: 2%; height: 78vh; overflow: auto; margin: 0 !important; padding: 20px"
        class="shadow-lg col">
        <form #wizardForm="ngForm">
          <!-- School Summary -->
          <div *ngIf="activeSteps.includes(1)" class="wizard-step">
            <h3>School Summary</h3>
            <label for="title">Project Title:</label>
            <input id="title" class="form-control mb-3" rows="1" name="title" placeholder="" required
                   [(ngModel)]="formData.title" #title="ngModel" (input)="onFormChange()"
                   [ngClass]="{'is-invalid': title.invalid && title.touched}">

            <label>Project Status:</label>
            <select class="form-select mb-3" name="projectStatus" [(ngModel)]="formData.projectStatus" required>
              <option value="" disabled>Select…</option>
              <option value="New">New</option>
              <option value="In Progress">In Progress</option>
              <option value="Completed">Completed</option>
              <option value="Rework">Rework</option>
              <option value="Abandoned">Abandoned</option>
            </select>

            <label for="representativeName">Teacher/Project Owner:</label>
            <select id="representativeName"
                    name="representativeName"
                    class="form-select"
                    [(ngModel)]="formData.representativeName"
                    (change)="onTeacherNameChanged()"
                    required>
              <option value="" disabled hidden>Select a teacher</option>
              <option *ngFor="let t of representativeList" [value]="t.fullName">
                {{ t.fullName }}
              </option>
            </select>

            <label for="representativeEmail" class="mt-3">Teacher Email:</label>
            <input id="representativeEmail" class="form-control" [(ngModel)]="formData.representativeEmail"
                   name="representativeEmail" readonly #representativeEmail="ngModel"
                   [ngClass]="{'is-invalid': representativeEmail.invalid && representativeEmail.touched}" required>

            <!-- Extra Representative 1 -->
            <div *ngIf="formData.extraRep1Visible" class="mt-2 border-top pt-2">
              <label for="rep2Email">Additional Team Member Email 1:</label>
              <select id="rep2Email"
                      class="form-select"
                      [(ngModel)]="formData.rep2Email"
                      name="rep2Email"
                      (click)="fillExtraRepresentatives()"
                      required>
                <option value="" disabled hidden>Select a teacher</option>
                <option *ngFor="let rep of extraRepresentatives" [value]="rep.email">
                  {{ rep.email }}
                </option>
              </select>
            </div>

            <!-- Extra Representative 2 -->
            <div *ngIf="formData.extraRep2Visible" class="mt-2 border-top pt-2">
              <label for="rep3Email">Additional Team Member Email 2:</label>
              <select id="rep3Email"
                      class="form-select"
                      [(ngModel)]="formData.rep3Email"
                      name="rep3Email"
                      (click)="fillExtraRepresentatives()"
                      required>
                <option value="" disabled hidden>Select a teacher</option>
                <option *ngFor="let rep of extraRepresentatives" [value]="rep.email">
                  {{ rep.email }}
                </option>
              </select>
            </div>

            <!-- Button row -->
            <div class="d-flex gap-2 mt-2">
              <button type="button" class="btn btn-outline-primary btn-sm" (click)="showNextRepField()"
                      [disabled]="formData.extraRep2Visible">
                + Add Team Member
              </button>
            </div>

            <div class="mb-3">
              <label for="schools" class="me-2 mt-3">School:</label>
              <select name="school" id="schools" class="form-select"
                      [(ngModel)]="formData.school" #school="ngModel"
                      [ngClass]="{'is-invalid': school.invalid && school.touched}" required>
                <option value="" disabled hidden>Select your school</option>
                <option *ngFor="let s of schools" [value]="s.name">
                  {{ s.name }}
                </option>
                <option value="other">Other</option>
              </select>
              <div *ngIf="school.invalid && school.touched" class="text-danger">
                Please select your school.
              </div>

              <div *ngIf="otherSchoolSelected" class="mt-2">
                <label for="customSchool">School Name:</label>
                <input id="customSchool" class="form-control mb-3" rows="1" name="customSchool" placeholder="" required
                       [(ngModel)]="formData.customSchool" #customSchool="ngModel"
                       [ngClass]="{'is-invalid': customSchool.invalid && customSchool.touched}">

              </div>
            </div>

            <div class="mt-3 mb-3 p-3 bg-light border rounded" *ngIf="getAssociatedAnnualProfileTeacher() != ''">
              <label class="me-2" for="associatedTeacher"><strong>Associated Annual School Profile GHS Teacher
                Rep:</strong></label>
              <span class="fs-5 text-primary" id="associatedTeacher">{{ getAssociatedAnnualProfileTeacher() }}</span>
              <small class="text-muted d-block">for current school</small>
            </div>

            <div class="mb-3">
              <label for="schoolYears" class="me-2">School Year:</label>
              <select name="schoolYear" id="schoolYears" class="form-select" [(ngModel)]="formData.schoolYear"
                      #schoolYear="ngModel" [ngClass]="{'is-invalid': schoolYear.invalid && schoolYear.touched}"
                      required>
                <option value="" disabled selected hidden></option>
                <option *ngFor="let schoolYear of schoolYears" [value]="schoolYear">
                  {{ schoolYear }}
                </option>
              </select>
              <div *ngIf="schoolYear.invalid && schoolYear.touched" class="text-danger">
                Please select the school year.
              </div>
            </div>

            <label for="projectImages">Upload Images:</label>
            <input [ngClass]="{'is-invalid': selectedImages.length > 10, 'mb-3': selectedImages.length <=10}"
                   class="form-control" type="file" id="projectImages" (change)="onFileSelected($event)" multiple/>
            <div *ngIf="selectedImages.length > 10" class="text-danger mb-3">
              You can only upload 10 images per project
            </div>
            <div *ngIf="selectedImages.length">
              <p class="mb-0">Selected Images:</p>
              <ul class="pt-0">
                <li *ngFor="let image of selectedImages">{{ image.name }}</li>
              </ul>
            </div>

            <!-- Cluster-Wide Effort Question -->
            <div class="mb-4">
              <label class="form-label d-block">
                Was this project part of a cluster-wide effort?
              </label>
              <div class="form-check form-check-inline">
                <input class="form-check-input" type="radio" name="clusterWideEffort" id="clusterYes" [value]="true"
                       [(ngModel)]="formData.isPartOfCluster" (ngModelChange)="onFormChange()">
                <label class="form-check-label" for="clusterYes">Yes</label>
              </div>
              <div class="form-check form-check-inline">
                <input class="form-check-input" type="radio" name="clusterWideEffort" id="clusterNo" [value]="false"
                       [(ngModel)]="formData.isPartOfCluster" (ngModelChange)="onFormChange()">
                <label class="form-check-label" for="clusterNo">No</label>
              </div>
              <small class="form-text text-muted d-block mt-1">
                A cluster-wide effort involves multiple schools working together on the same initiative.
              </small>
            </div>

            <label for="teachingLevel" class="me-2">Primary Teaching Level:</label>
            <div class="d-flex flex-column mb-3">
              <div>
                <input type="radio" id="elementary" name="teachingLevel" [(ngModel)]="formData.teachingLevel"
                       value="elementary" required>
                <label for="elementary">Elementary School</label>
              </div>

              <div>
                <input type="radio" id="middle" name="teachingLevel" [(ngModel)]="formData.teachingLevel" value="middle"
                       required>
                <label for="middle">Middle School</label>
              </div>
              <div>
                <input type="radio" id="high" name="teachingLevel" [(ngModel)]="formData.teachingLevel" value="high"
                       required>
                <label for="high">High School</label>
              </div>
            </div>

            <label for="grades" class="me-2">Grades:</label>
            <div class="row">
              <div class="col-md-6">
                <label *ngFor="let level of getFirstHalf(grades)" class="form-check mb-2">
                  <input type="checkbox" class="form-check-input" [checked]="formData.grades.includes(level)"
                         (change)="toggleGradeSelection(level, $event)"/>
                  <span>{{ level }}</span>
                </label>
              </div>

              <div class="col-md-6">
                <label *ngFor="let level of getSecondHalf(grades)" class="form-check mb-2">
                  <input type="checkbox" class="form-check-input" [checked]="formData.grades.includes(level)"
                         (change)="toggleGradeSelection(level, $event)"/>
                  <span>{{ level }}</span>
                </label>
              </div>
            </div>
            <div class="form-check text-start mt-3">
              <input class="form-check-input" type="checkbox" id="ack" name="acknowledgement"
                     [(ngModel)]="formData.acknowledgement" required>
              <label class="form-check-label" for="ack">
                <em>In submitting this data I acknowledge that data will be used in downstream reporting by
                  Gwinnett Clean &amp; Beautiful and that any photos are eligible for sharing.</em>
              </label>
            </div>
          </div>

          <!-- Environmental Project Details -->
          <div *ngIf="activeSteps.includes(2)" class="wizard-step">
            <!-- Christian Zarate Changed h4 from Student Environmental Projects to Project Details and Status-->
            <h3>Environmental Project Details</h3>
            <label for="projectDesc">Describe your project:</label>
            <textarea id="projectDesc" class="form-control mb-3" rows="2" [(ngModel)]="formData.projectDesc"
                      name="projectDesc" [required]="formData.projectStatus === 'Completed'">
        </textarea>

            <div class="d-flex gap-5 mb-4">
              <div class="d-flex gap-0 flex-column flex-grow-1 text-start">
                <label class="form-label align-self-start mb-0" for="startDate">Project Start Date</label>
                <input [(ngModel)]="formData.startDate" id="startDate" name="startDate" class="form-control"
                       type="date"/>
              </div>

              <div class="d-flex gap-0 flex-column flex-grow-1 text-start">
                <label class="form-label align-self-start mb-0" for="endDate">Project End Date</label>
                <input [(ngModel)]="formData.endDate" id="endDate" name="endDate" class="form-control" type="date"/>
              </div>
            </div>

            <label for="clubs">Other than your class, did any clubs participate?</label>
            <textarea id="clubs" class="form-control mb-3" rows="2" name="clubs" [(ngModel)]="formData.projectClubs"
                      [required]="formData.projectStatus === 'Completed'"></textarea>

            <label for="impact">What was the outcome of your project?</label>
            <textarea id="impact" class="form-control mb-3" rows="3" [(ngModel)]="formData.impact" name="impact"
                      [required]="formData.projectStatus === 'Completed'">
        </textarea>

            <label for="numStudentsInProject" class="me-2">Number of Students Involved in Project:</label>
            <input type="number" [(ngModel)]="formData.numStudentsInProject" class="form-control mb-3"
                   name="numStudentsInProject" id="numStudentsInProject" min="0" max="9999" style="max-width: 5rem;"
                   #numStudentsInProject="ngModel"
                   [ngClass]="{'is-invalid': numStudentsInProject.invalid && numStudentsInProject.touched}"
                   [required]="formData.projectStatus === 'Completed'" appIntegerInput>

            <label for="numTeachersInProject" class="me-2">Number of Teachers Involved in Project:</label>
            <input type="number" [(ngModel)]="formData.numTeachersInProject" class="form-control mb-3"
                   name="numTeachersInProject" id="numTeachersInProject" min="0" max="9999" style="max-width: 5rem;"
                   #numTeachersInProject="ngModel" (ngModelChange)="calculateParticipationHours()"
                   [ngClass]="{'is-invalid': numTeachersInProject.invalid && numTeachersInProject.touched}"
                   [required]="formData.projectStatus === 'Completed'" appIntegerInput>
            <label for="eventDuration" class="me-2">Event Duration (in hours):</label>
            <input type="number" [(ngModel)]="formData.eventDuration" class="form-control mb-3" name="eventDuration"
                   id="eventDuration" min="0" max="99" style="max-width: 5rem;" #eventDuration="ngModel"
                   [ngClass]="{'is-invalid': eventDuration.invalid && eventDuration.touched}"
                   [required]="formData.projectStatus === 'Completed'" step="0.01"
                   (ngModelChange)="calculateParticipationHours()">

            <div class="mt-3 p-3 bg-light border rounded">
              <label class="me-2" for="numParticipationHours"><strong>Number of Participation Hours
                (calculated):</strong></label>
              <span class="fs-5 text-primary" id="numParticipationHours">{{ formData.numParticipationHours || 0 }}
                H</span>
              <small class="text-muted d-block">Auto-calculated</small>
            </div>
          </div>

          <!-- Select Categories -->
          <div *ngIf="activeSteps.includes(3)" class="wizard-step">
            <!--Christian Zarate added Expandable checkboxes-->
            <h3>Select Category and SubCategories</h3>
            <!-- Food Waste-->
            <div class="section">
              <input type="checkbox" id="foodwasteToggle" name="foodwasteToggle"
                     [(ngModel)]="formData.foodwasteToggle"
              >
              <label for="foodwasteToggle">Food Waste Reduction</label>
              <div class="panel">
                <label>
                  <input type="checkbox" id="educationalcampaign1" name="educationalcampaign1"
                         [(ngModel)]="formData.educationalcampaign1"
                  >
                  Educational Campaign
                </label>

                <label>
                  <input type="checkbox" id="sharetable1" name="sharetable1"
                         [(ngModel)]="formData.sharetable1"
                  >
                  Share Table
                </label>

                <label>
                  <input type="checkbox" id="composting" name="composting"
                         [(ngModel)]="formData.compostingSelected"
                  >
                  Composting
                </label>

                <label>
                  <input type="checkbox" id="pantry" name="pantry"
                         [(ngModel)]="formData.pantry"
                  >
                  Food Pantry
                </label>

                <label>
                  <input type="checkbox" id="fwasteaudit" name="fwasteaudit"
                         [(ngModel)]="formData.fwasteaudit"
                  >
                  Food Waste Audit
                </label>

                <input type="checkbox" id="foodOther" name="foodOtherCheck"
                       [(ngModel)]="formData.foodOtherCheck"
                >
                <label for="foodOther">Other</label>
                <div class="other-text">
                  <textarea class="form-control" rows="3" cols="30" name="foodOtherComment" [(ngModel)]="formData.foodOtherComment"
                placeholder="Please Specify..." maxlength="50"></textarea>
                </div>

              </div>
            </div>

            <!-- Outdoor Learning Spaces-->
            <div class="section">
              <input type="checkbox" id="OutdoorToggle" name="outdoorToggle">
              <label for="OutdoorToggle">Outdoor Learning Spaces</label>
              <div class="panel">

                <label><input type="checkbox" name="garden" id="garden" value="gardens"
                              [(ngModel)]="formData.outdoorSelected">Gardens- different types, pollinator, edible,
                  herbs,
                  flowers, other
                  etc.</label>

                <label><input type="checkbox" name="fish" id="fish" value="fishhatchery" [(ngModel)]="formData.fish">Fish
                  Hatchery</label>

                <label><input type="checkbox" name="chicken" id="chicken" value="chickens"
                              [(ngModel)]="formData.chicken">Chickens and other farm animals - goats, rabbits,
                  other</label>

                <label><input type="checkbox" name="class" id="class" value="classroom"
                              [(ngModel)]="formData.class">Outdoor Classroom/Gazebos/seating</label>

                <label><input type="checkbox" name="trails" id="trails" [(ngModel)]="formData.trails"> Trails / Forested
                  Area</label>

                <label><input type="checkbox" name="greenhouse" id="greenhouse" [(ngModel)]="formData.greenhouse">
                  Greenhouse(s)</label>

                <label><input type="checkbox" name="compostSystem" id="compostSystem"
                              [(ngModel)]="formData.compostSystem"> Composting System</label>

                <label><input type="checkbox" name="pollinatorCensus" id="pollinatorCensus"
                              [(ngModel)]="formData.pollinatorCensus"> Southeast Pollinator Census</label>

                <input type="checkbox" id="outdoorOther" name="outdoorOtherCheck" value="Other"
                       [(ngModel)]="formData.outdoorOtherCheck">
                <label for="outdoorOther">Other</label>
                <div class="other-text">
                <textarea class="form-control" row="3" cols="30" name="outdoorOtherComment" placeholder="Please Specify..."
                          [(ngModel)]="formData.outdoorOtherComment" maxlength="50"></textarea>
                </div>


              </div>
            </div>

            <!-- Indoor Growing Systems-->
            <div class="section">
              <input type="checkbox" id="IndoorToggle" name="indoorToggle" [(ngModel)]="formData.indoorSelected">
              <label for="IndoorToggle">Indoor Growing Systems</label>
              <div class="panel">
                <label><input type="checkbox" name="hydroponics1" id="hydroponics1" value="hydroponics"
                              [(ngModel)]="formData.hydroponics1">Hydroponics</label>

                <label><input type="checkbox" name="aquaponics1" id="aquaponics1" value="aquaponics"
                              [(ngModel)]="formData.aquaponics1">Aquaponics</label>

                <label><input type="checkbox" name="aeroponics1" id="aeroponics1" value="aeroponics"
                              [(ngModel)]="formData.aeroponics1">Aeroponics</label>

                <label><input type="checkbox" name="towers1" id="towers1" value="towers"
                              [(ngModel)]="formData.towers1">Grow Towers/systems</label>


                <input type="checkbox" id="indoorOther" name="indoorOtherCheck" value="Other"
                       [(ngModel)]="formData.indoorOtherCheck">
                <label for="indoorOther">Other</label>
                <div class="other-text">
                <textarea class="form-control" row="3" cols="30" name="indoorOtherComment" placeholder="Please Specify..."
                          [(ngModel)]="formData.indoorOtherComment" maxlength="50"></textarea>
                </div>
              </div>

            </div>

            <div class="section">
              <input type="checkbox"
                     id="WaterToggle"
                     name="WaterToggle"
                     [(ngModel)]="formData.WaterToggle">

              <label for="WaterToggle">Watershed Programs</label>

              <div class="panel">

                <!-- Water Educational Campaign -->
                <label>
                  <input type="checkbox"
                         name="waterEducationalCampaign"
                         id="waterEducationalCampaign"
                         [(ngModel)]="formData.waterEducationalCampaign">
                  Water Educational Campaign
                </label>

                <!-- Adopt-A-Road -->
                <label>
                  <input type="checkbox" id="adoptARoadWatershed" name="adoptARoadWatershed"
                         [(ngModel)]="formData.adoptARoadWatershed">
                  Adopt-A-Road
                </label>

                <!-- Adopt-A-Stream Clean-up -->
                <label>
                  <input type="checkbox"
                         id="adoptAStreamCleanup"
                         name="adoptAStreamCleanup"
                         [(ngModel)]="formData.adoptAStreamCleanup">
                  Adopt-A-Stream Clean-up
                </label>

                <!-- Adopt-A-Stream Monitoring -->
                <label>
                  <input type="checkbox"
                         id="adoptAStreamMonitoring"
                         name="adoptAStreamMonitoring"
                         [(ngModel)]="formData.adoptAStreamMonitoring">
                  Adopt-A-Stream Monitoring
                </label>

                <!-- Stream Restoration/Erosion Control -->
                <label>
                  <input type="checkbox"
                         id="streamRestoration"
                         name="streamRestoration"
                         [(ngModel)]="formData.streamRestoration">
                  Stream Restoration/Erosion Control
                </label>

              </div>
            </div>

            <!---->
            <div class="section">

              <input type="checkbox" id="WatershedProjectsToggle" name="WatershedProjectsToggle"
                     [(ngModel)]="formData.WatershedProjectsToggle">

              <label for="WatershedProjectsToggle">Community Watershed Events</label>

              <div class="panel">

                <label>
                  <input type="checkbox" id="greatDaysService" name="greatDaysService"
                         [(ngModel)]="formData.greatDaysService">
                  GC&B Great Days of Service
                </label>

                <label>
                  <input type="checkbox" id="wetlandCleanup" name="wetlandCleanup"
                         [(ngModel)]="formData.wetlandCleanup">
                  GC&B Wetland Cleanup
                </label>

                <label>
                  <input type="checkbox" id="yellowRiverTrashBash" name="yellowRiverTrashBash"
                         [(ngModel)]="formData.yellowRiverTrashBash">
                  Yellow River Trash Bash
                </label>

                <label>
                  <input type="checkbox" id="shoreSweep" name="shoreSweep" [(ngModel)]="formData.shoreSweep">
                  Shore Sweep (Lake Lanier)
                </label>

                <!-- This one has a text area below it -->
                <label class="form-check-label d-block">
                  <input type="checkbox" id="localWaterEvent" name="localWaterEvent"
                         [(ngModel)]="formData.localWaterEvent">
                  Other local water-related event (enter comment)

                  <div class="other-text">
                  <textarea rows="2" cols="30" class="form-control w-auto mt-2" name="localWaterEventComment"
                            placeholder="Please Specify..." [(ngModel)]="formData.localWaterEventComment" maxlength="50"
                            class="form-control mt-2"></textarea>
                  </div>
                </label>


                <label>
                  <input type="checkbox" id="gwinnettServiceDept" name="gwinnettServiceDept"
                         [(ngModel)]="formData.gwinnettServiceDept">
                  Other Gwinnett County Service Dept.
                </label>

                <label>
                  <input type="checkbox" id="supportCharity" name="supportCharity"
                         [(ngModel)]="formData.supportCharity">
                  Support local charity or non-profit
                </label>

                <!--<label>
                  <input type="checkbox" id="studentProjects" name="studentProjects"
                         [(ngModel)]="formData.studentProjects">
                  Other student or school-led projects
                </label>-->

              </div>
            </div>
            <!---->
            <div class="section">
              <input type="checkbox" id="watershedTrips" name="watershedTripsToggle"
                     [(ngModel)]="formData.watershedTripsToggle">
              <label for="watershedTrips">Watershed Field Trips / In-house Programs</label>
              <div class="panel">
                <label><input type="checkbox" name="wasteWaterPlant" id="wasteWaterPlant" value="wasteWaterPlant"
                              [(ngModel)]="formData.wasteWaterPlant">Waste Water Plant</label>

                <label><input type="checkbox" name="watersheddrinkingWaterPlant" id="watersheddrinkingWaterPlant"
                              value="watersheddrinkingWaterPlant" [(ngModel)]="formData.watersheddrinkingWaterPlant">Drinking
                  Water
                  Plant</label>

                <label><input type="checkbox" name="theWaterTower" id="theWaterTower" value="theWaterTower"
                              [(ngModel)]="formData.theWaterTower">The Water Tower</label>

                <label><input type="checkbox" name="deptOfWaterResources" id="deptOfWaterResources"
                              value="deptOfWaterResources" [(ngModel)]="formData.deptOfWaterResources">Dept of Water
                  Resources</label>

                <label><input type="checkbox" name="gwinnettCleanBeautiful" id="gwinnettCleanBeautiful"
                              value="gwinnettCleanBeautiful" [(ngModel)]="formData.gwinnettCleanBeautiful">Gwinnett
                  Clean &
                  Beautiful</label>

                <label>
                  <input
                    type="checkbox"
                    name="elachee"
                    id="elachee"
                    [(ngModel)]="formData.elachee">
                  Elachee Nature Center
                </label>

                <input type="checkbox" id="watershedOther" name="watershedOtherCheck" value="Other"
                       [(ngModel)]="formData.watershedOtherCheck">
                <label for="watershedOther" class="other">Other</label>
                <div class="other-text">
                <textarea class="form-control" rows="3" cols="30" name="watershedOtherComment" placeholder="Please Specify..."
                          [(ngModel)]="formData.watershedOtherComment" maxlength="50"></textarea>
                </div>
              </div>

            </div>
            <!---->
            <div class="section">
              <input type="checkbox" id="RecyclingToggle" name="recyclingToggle"
                     [(ngModel)]="formData.recyclingSelected">
              <label for="RecyclingToggle">Recycling items</label>

              <div class="panel">

                <label><input type="checkbox" name="paper1" id="paper1" value="paper"
                              [(ngModel)]="formData.paperAndCardboard">Paper & Cardboard</label>

                <label><input type="checkbox" name="textiles1" id="textiles1" value="textiles"
                              [(ngModel)]="formData.textiles1">Textiles</label>

                <label><input type="checkbox" name="pastics1" id="plastics1" value="plastics"
                              [(ngModel)]="formData.plastics1">Plastics</label>

                <label><input type="checkbox" name="aluminumcans1" id="aluminumcans1" value="aluminumcans"
                              [(ngModel)]="formData.aluminumcans1">Aluminum Cans</label>

                <input type="checkbox" id="recycleOther" name="recycleOtherCheck" value="Other"
                       [(ngModel)]="formData.recycleOtherCheck">
                <label for="recycleOther" class="other">Other</label>
                <div class="other-text">
                <textarea class="form-control" row="3" cols="30" name="recycleOtherComment" placeholder="Please Specify..."
                          [(ngModel)]="formData.recycleOtherComment" maxlength="50"></textarea>
                </div>
              </div>

            </div>
            <!---->
            <div class="section">

              <input type="checkbox" id="RecyclingEventsToggle" name="recyclingEventsToggle"
                     [(ngModel)]="formData.recyclingEventsToggle">

              <label for="RecyclingEventsToggle">Recycling Events</label>

              <div class="panel">

                <label><input type="checkbox" id="chipperEvent" name="chipperEvent"
                              [(ngModel)]="formData.chipperEvent">Bring One for the Chipper – Christmas Tree
                  Recycling</label>

                <label><input type="checkbox" id="earthDayEvent" name="earthDayEvent"
                              [(ngModel)]="formData.earthDayEvent">Earth Day</label>

                <label><input type="checkbox" id="americaRecyclesEvent" name="americaRecyclesEvent"
                              [(ngModel)]="formData.americaRecyclesEvent">America Recycles Day</label>

                <input type="checkbox" id="recyclingEventsOther" name="recyclingEventsOtherCheck" value="Other"
                       [(ngModel)]="formData.recyclingEventsOtherCheck">
                <label for="recyclingEventsOther">Other</label>

                <div class="other-text">
                <textarea class="form-control" row="3" cols="30" name="recyclingEventsOtherComment" placeholder="Please Specify..."
                          [(ngModel)]="formData.recyclingEventsOtherComment" maxlength="50"></textarea>
                </div>

              </div>
            </div>
            <!---->
            <div class="section">

              <input type="checkbox" id="RenewableToggle" name="renewableToggle" [(ngModel)]="formData.renewableToggle">

              <label for="RenewableToggle">Renewable Energy</label>

              <div class="panel">

                <label><input type="checkbox" name="solar1" id="solar1" value="solar"
                              [(ngModel)]="formData.solar1">Solar</label>

                <label><input type="checkbox" name="wind1" id="wind1" value="wind"
                              [(ngModel)]="formData.wind1"> Wind</label>

                <label><input type="checkbox" name="water1" id="water1" value="water"
                              [(ngModel)]="formData.water1">Water</label>
                <!-- <label><input type="checkbox" name="hydroelectric1" id="hydroelectric1" value="hydroelectric"  [(ngModel)]="formData.hydroelectric1">Hydroelectric</label>

                <label><input type="checkbox" name="biomass1" id="biomass1" value="biomass"  [(ngModel)]="formData.biomass1">Biomass</label>

                <label><input type="checkbox" name="geothermal1" id="geothermal1" value="geothermal"  [(ngModel)]="formData.geothermal1">Geothermal</label> -->
                <!-- <input type="checkbox" id="renewableOther" name="renewableOtherCheck"  value="Other"  [(ngModel)]="formData.renewableOtherCheck">
                <label for="renewableOther">Other</label>
                <div class="other-text">
                  <textarea row="3" cols="30" name="renewableOtherComment" placeholder="Please Specify..."  [(ngModel)]="formData.renewableOtherComment"></textarea>
                </div> -->
              </div>

            </div>

            <div *ngIf="nav?.isResultSelected()">
              <h3>Results</h3>
            </div>
          </div>

          <!-- Community Partners -->
          <div *ngIf="activeSteps.includes(4)" class="wizard-step">
            <h3>Community Partners</h3>
            <p class="mb-0">Describe community involvement in your project:</p>
            <textarea id="communityPartners" class="form-control mb-3" rows="3" [(ngModel)]="formData.communityPartners"
                      name="communityPartners"></textarea>
            <!--Christian Zarate added Support & Community checkboxes-->

            <!-- Section 10 -->
            <h4 class="mt-3">Support & Community Activities</h4>

            <label>
              Number of community members engaged in project (if applicable):
              <input type="number" name="community_members" min="0" [(ngModel)]="formData.numCommunityMembers">
            </label>
            <br><br>
            <label>
              Number of parents engaged in project (if applicable):
              <label>
                Number of parents engaged in project (if applicable):
                <input type="number" name="parents_engaged" min="0" [(ngModel)]="formData.numParentsEngaged">
              </label>
            </label>
            <br><br>
            <label>
              Number of hours the non-school volunteers were engaged (community, parents, etc):
              <input type="number" name="volunteer_hours" min="0" [(ngModel)]="formData.numVolunteerHours">
            </label>
            <br><br>

            <h6 class="fw-bold mt-2">Select all types of community support received:</h6>

            <div class="row">
              <!-- Left column -->
              <div class="col-md-6">
                <div class="form-check mb-2">
                  <input type="checkbox" class="form-check-input" [checked]="formData.support.includes('speaker')"
                         (change)="toggleSupportSelection('speaker', $event)"/>
                  <label class="form-check-label">Speaker</label>
                </div>

                <div class="form-check mb-2">
                  <input type="checkbox" class="form-check-input"
                         [checked]="formData.support.includes('virtualFieldTrip')"
                         (change)="toggleSupportSelection('virtualFieldTrip', $event)"/>
                  <label class="form-check-label">Virtual Field Trip</label>
                </div>

                <div class="form-check mb-2">
                  <input type="checkbox" class="form-check-input"
                         [checked]="formData.support.includes('inPersonFieldTrip')"
                         (change)="toggleSupportSelection('inPersonFieldTrip', $event)"/>
                  <label class="form-check-label">In-Person Field Trip</label>
                </div>

                <div class="form-check mb-2">
                  <input type="checkbox" class="form-check-input" [checked]="formData.support.includes('adoptARoad')"
                         (change)="toggleSupportSelection('adoptARoad', $event)"/>
                  <label class="form-check-label">Adopt-A-Road</label>
                </div>
              </div>

              <!-- Right column -->
              <div class="col-md-6">
                <div class="form-check mb-2">
                  <input type="checkbox" class="form-check-input" [checked]="formData.support.includes('adoptAStream')"
                         (change)="toggleSupportSelection('adoptAStream', $event)"/>
                  <label class="form-check-label">Adopt-A-Stream</label>
                </div>

                <div class="form-check mb-2">
                  <input type="checkbox" class="form-check-input"
                         [checked]="formData.support.includes('christmasTreeRecycling')"
                         (change)="toggleSupportSelection('christmasTreeRecycling', $event)"/>
                  <label class="form-check-label">Christmas Tree Recycling</label>
                </div>

                <div class="form-check mb-2">
                  <input type="checkbox" class="form-check-input"
                         [checked]="formData.support.includes('watershedCleanup')"
                         (change)="toggleSupportSelection('watershedCleanup', $event)"/>
                  <label class="form-check-label">Watershed Cleanups</label>
                </div>

                <div class="form-check mb-2">
                  <input type="checkbox" class="form-check-input" [checked]="formData.support.includes('noPartner')"
                         (change)="toggleSupportSelection('noPartner', $event)"/>
                  <label class="form-check-label">We did not partner with any community agencies</label>
                </div>
              </div>
            </div>

            <!-- Separate "Other" option -->
            <div class="form-check mt-3">
              <input type="checkbox" class="form-check-input" [checked]="formData.support.includes('other')"
                     (change)="toggleSupportSelection('other', $event)"/>
              <label class="form-check-label">Other</label>
            </div>

            <!-- Textarea appears only when "Other" is selected -->
            <div class="mt-2" *ngIf="formData.support.includes('other')">
            <textarea rows="2" cols="30" class="form-control" placeholder="Please specify…"
                      [(ngModel)]="formData.supportOther" name="supportOther" maxlength="50"></textarea>
            </div>
            <br>

            <!-- Community Partners + Contact Info -->
            <h5 class="mt-3">List of Community Partners & Contact Information</h5>
            <textarea rows="3" class="form-control mb-3" [(ngModel)]="formData.communityPartnersContactInfo"
                      name="communityPartnersContactInfo"
                      placeholder="Example: Keep GA Beautiful – Jane Smith (770-555-1234, jsmith@example.com)">
            </textarea>

            <p>Clubs:</p>
            <textarea id="clubs" class="form-control mb-3" rows="3" name="clubs" [(ngModel)]="formData.clubs"
                      maxlength="100"> </textarea>

            <!-- Field trip destination -->
            <p>Where did the students take a field trip?</p>
            <textarea id="fieldtrip" class="form-control mb-3" rows="3" name="fieldtrip"
                      [(ngModel)]="formData.fieldtrip"
                      maxlength="100"></textarea>

            <!-- Grant & Supplies Received -->
            <p>Grant or Supplies Received:</p>
            <textarea id="grantSupplies" class="form-control mb-3" rows="3" name="grantSupplies"
                      [(ngModel)]="formData.grantSupplies" placeholder="Describe grants or supplies received"
                      maxlength="150"></textarea>

            <p>Funder/Donor Name & Comments</p>
            <textarea id="grant" class="form-control mb-3" rows="3" name="grant"
                      [(ngModel)]="formData.funderAndDonorNameAndComments" maxlength="100"> </textarea>
            <p>Amount:</p>
            <input type="number" id="amount" name="amount" [(ngModel)]="formData.amount" class="form-control"
                   style="max-width: 8rem;" min="0" step="0.01">
          </div>

          <div *ngIf="activeSteps.includes(5)" class="wizard-step">
            <h4>Food Waste</h4>
            <label for="foodWasteDesc">If your school participated in efforts to reduce cafeteria food waste,
              describe them:</label>
            <textarea id="foodWasteDesc" class="form-control mb-3" rows="3" [(ngModel)]="formData.foodWasteDesc"
                      name="foodWasteDesc" required>
        </textarea>

            <label for="strategies">What strategies were used to reduce cafeteria food waste?</label>
            <textarea id="strategies" class="form-control mb-3" rows="2" name="strategies"
                      [(ngModel)]="formData.foodWasteStrategies" required></textarea>


            <label for="foodWastePounds" class="me-2">Approximately how many pounds of food were recovered for the share
              table?</label>
            <input type="number" [(ngModel)]="formData.foodWastePounds" class="form-control mb-3" name="foodWastePounds"
                   id="foodWastePounds" min="0" max="99" style="max-width: 5rem;" #foodWastePounds="ngModel"
                   [ngClass]="{'is-invalid': foodWastePounds.invalid && foodWastePounds.touched}" required
                   appIntegerInput>

            <label for="shareTablePounds" class="me-2">Approximately how many pounds of food waste was
              generated?</label>
            <input type="number" [(ngModel)]="formData.shareTablePounds" class="form-control mb-3"
                   name="shareTablePounds"
                   id="shareTablePounds" min="0" max="99" style="max-width: 5rem;" #shareTablePounds="ngModel"
                   [ngClass]="{'is-invalid': shareTablePounds.invalid && shareTablePounds.touched}" required
                   appIntegerInput>

            <label for="recoverableItemTypes" class="me-2">
              Types of recoverable items used in share table (text 250 characters)
            </label>
            <textarea id="recoverableItemTypes" name="recoverableItemTypes" maxlength="250" rows="4" cols="50"
                      class="form-control mb-3" [(ngModel)]="formData.recoverableItemTypes"></textarea>
          </div>

          <!--Composting-->
          <div *ngIf="activeSteps.includes(6) && formData.compostingSelected" class="wizard-step">
            <h3>Composting</h3>

            <div>
              <label for="lbsFoodScrapsComposted" class="me-2">
                Lbs of cafeteria food scraps composted:
              </label>
              <input type="number" [(ngModel)]="formData.lbsFoodScrapsComposted" class="form-control mb-3"
                     name="lbsFoodScrapsComposted" id="lbsFoodScrapsComposted" min="0" max="9999"
                     style="max-width: 8rem;" #lbsFoodScrapsComposted="ngModel" [ngClass]="{'is-invalid': lbsFoodScrapsComposted.invalid &&
                     lbsFoodScrapsComposted.touched }" appIntegerInput/>

              <div class="mt-3">
                <label>Composting System: </label>
                <div *ngFor="let sys of compostingSysOptions">
                  <input
                    type="checkbox"
                    [value]="sys"
                    (change)="toggleArrayValue(formData.compostingSystem, sys, $event)"
                  />
                  {{ sys }}
                </div>
              </div>

              <div class="mt-3">
                <label>Compost used for:</label>
                <div *ngFor="let used of compostUsedOptions">
                  <input
                    type="checkbox"
                    [value]="used"
                    (change)="toggleArrayValue(formData.compostUsed, used, $event)"
                  />
                  {{ used }}
                </div>
              </div>

              <div class="mt-3">
                <label>
                  Were food scraps donated to a non-profit?
                </label>
                <div class="d-flex gap-3">
                  <div>
                    <input type="radio" id="donatedYes" name="foodScrapsDonated"
                           [(ngModel)]="formData.foodScrapsDonated"
                           value="yes"/>
                    <label for="donatedYes">Yes</label>
                  </div>
                  <div>
                    <input type="radio" id="donatedNo" name="foodScrapsDonated" [(ngModel)]="formData.foodScrapsDonated"
                           value="no"/>
                    <label for="donatedNo">No</label>
                  </div>
                </div>
              </div>

              <div *ngIf="formData.foodScrapsDonated === 'yes'" class="mt-3">
                <label for="foodScrapsRecipients">
                  If yes, list recipients:
                </label>
                <input type="text" id="foodScrapsRecipients" name="foodScrapsRecipients"
                       [(ngModel)]="formData.foodScrapsRecipients" maxlength="100"
                       placeholder="Enter recipient names (max 100 chars)" class="form-control"/>
                <small class="text-muted">100 character limit</small>
              </div>
            </div>
          </div>

          <!-- Gardens 7 is DONE -->
          <div *ngIf="activeSteps.includes(7) && formData.outdoorSelected" class="wizard-step">
            <h3>Gardens</h3>
            <h4>School Gardens and Outdoor Learning Spaces</h4>
            <div>
              <!-- Garden Types -->
              <label class="mt-3 mb-2">What types of gardens do you have? (Select all that apply)</label>

              <div *ngFor="let type of gardenOptions">
                <input
                  type="checkbox"
                  [value]="type"
                  (change)="toggleArrayValue(formData.gardenTypes, type, $event)"
                />
                {{ type }}
              </div>

              <div *ngIf="formData.gardenTypes.includes('Other')">
                <label for="gardenTypeOtherComment">Please specify other garden type:</label>
                <input type="text" id="gardenTypeOtherComment" class="form-control mb-3" name="gardenTypeOtherComment"
                       [(ngModel)]="formData.gardenTypeOtherComment" maxlength="100"
                       placeholder="Enter other garden type (max 100 characters)"/>
              </div>

              <label class="me-2 mt-3">Were students/families provided produce?</label>
              <div class="form-check">
                <input class="form-check-input" type="radio" name="studentsProvidedProduce" [value]="true"
                       id="studentsProducedYes" [(ngModel)]="formData.studentsProvidedProduce"/>
                <label class="form-check-label" for="studentsProducedYes">Yes</label>
              </div>
              <div class="form-check mb-3">
                <input class="form-check-input" type="radio" name="studentsProvidedProduce" [value]="false"
                       id="studentsProducedNo" [(ngModel)]="formData.studentsProvidedProduce"/>
                <label class="form-check-label" for="studentsProducedNo">No</label>

                <div *ngIf="formData.studentsProvidedProduce">
                  <label class="mb-3">If so, how many families were served by gardens?</label>
                  <input type="number" class="form-control mb-3" style="max-width: 10rem;" min="0" max="99999"
                         name="familiesServedByGarden"
                         appIntegerInput
                         [(ngModel)]="formData.familiesServedByGarden">
                  <label class="form-check-label" for="productPoundsDonated">Approx. how many lbs. of produce was
                    donated?</label>
                  <input type="number" [(ngModel)]="formData.productPoundsDonated" class="form-control mb-3"
                         name="productPoundsDonated" id="productPoundsDonated" min="0" max="99999"
                         style="max-width: 10rem;"
                         #productPoundsDonated="ngModel"
                         [ngClass]="{'is-invalid': productPoundsDonated.invalid && productPoundsDonated.touched}"
                         appIntegerInput>
                </div>
              </div>
            </div>
          </div>

          <!-- Step 8: Indoor Growing System -->
          <div *ngIf="activeSteps.includes(8)" class="wizard-step">
            <h3>Indoor Growing System</h3>
            <label for="indoorGrowing" class="mb-2">
              Does your school have an indoor growing system?
            </label>

            <div class="d-flex flex-column">
              <div class="d-flex align-items-center mb-2">
                <input type="radio" id="indoorYes" name="indoorGrowing" required [(ngModel)]="formData.indoorGrowing"
                       value="yes"/>
                <label for="indoorYes" class="ms-2">Yes</label>
              </div>
              <div class="d-flex align-items-center mb-2">
                <input type="radio" id="indoorNo" name="indoorGrowing" required [(ngModel)]="formData.indoorGrowing"
                       value="no"/>
                <label for="indoorNo" class="ms-2">No</label>
              </div>
            </div>

            <div *ngIf="formData.indoorGrowing === 'yes'">
              <label for="indoorDetails" class="mt-3">Describe the indoor growing system:</label>
              <textarea *ngIf="formData.indoorGrowing === 'yes'" id="indoorDetails" class="form-control" rows="3"
                        name="indoorDetails" [(ngModel)]="formData.indoorDetails"
                        [required]="formData.indoorGrowing === 'yes'"
                        [disabled]="formData.indoorGrowing !== 'yes'">
  </textarea>

              <!-- Items grown -->
              <label class="mt-3">
                Items grown:
              </label>
              <input type="text" maxlength="100" [(ngModel)]="formData.indoorItemsGrown" class="form-control"/>


              <!-- Pounds donated -->
              <label class="mt-3">
                Pounds of indoor food grown donated:
              </label>
              <input type="number" min="0" [(ngModel)]="formData.indoorFoodDonatedLbs" class="form-control"/>
            </div>
          </div>

          <!--Step 9: Recycling -->
          <div *ngIf="activeSteps.includes(9)" class="wizard-step">
            <h3>Recycling</h3>
            <label for="recycling" class="mb-2">
              Does your school contact with a local company for recycling?
            </label>

            <div class="d-flex flex-column">
              <div class="d-flex align-items-center mb-2">
                <input type="radio" id="recyclingYes" name="recycling" required [(ngModel)]="formData.recycling"
                       value="yes"/>
                <label for="recyclingYes" class="ms-2">Yes</label>
              </div>
              <div class="d-flex align-items-center mb-2">
                <input type="radio" id="recyclingNo" name="recycling" required [(ngModel)]="formData.recycling"
                       value="no"/>
                <label for="recyclingNo" class="ms-2">No</label>
              </div>
            </div>
            <div *ngIf="formData.recycling === 'yes'">
              <label for="recyclingDetails" class="mt-3">Describe the recycling efforts:</label>
              <textarea id="recyclingDetails" class="form-control mb-3" rows="3" name="recyclingDetails"
                        [(ngModel)]="formData.recyclingDetails" [required]="formData.recycling === 'yes'"
                        [disabled]="formData.recycling !== 'yes'">
  </textarea>

              <!-- Recycling Details -->
              <label class="mt-3">
                Does your school contract with a company for recycling pick-up?
              </label>
              <div class="mb-3">
                <div class="form-check form-check-inline">
                  <input class="form-check-input" type="radio" id="recyclingContractYes" name="recyclingContract"
                         value="yes" [(ngModel)]="formData.recyclingContractOption">
                  <label class="form-check-label" for="recyclingContractYes">Yes</label>
                </div>
                <div class="form-check form-check-inline">
                  <input class="form-check-input" type="radio" id="recyclingContractNo" name="recyclingContract"
                         value="no" [(ngModel)]="formData.recyclingContractOption">
                  <label class="form-check-label" for="recyclingContractNo">No</label>
                </div>
              </div>

              <!-- Company / Hauler Name -->
              <label for="recyclingCompany" class="mt-2">
                If yes, what is the name of the company/hauler?
              </label>
              <input type="text" id="recyclingCompany" class="form-control mb-3" name="recyclingCompany"
                     [(ngModel)]="formData.recyclingCompany" [required]="formData.recyclingContractOption === 'yes'"
                     [disabled]="formData.recyclingContractOption !== 'yes'" placeholder="Enter company or hauler name">

              <!-- Items Collected -->
              <label for="recyclingItems" class="mt-2">
                What items are collected for recycling?
              </label>
              <textarea id="recyclingItems" class="form-control mb-3" rows="3" name="recyclingItems"
                        [(ngModel)]="formData.recyclingItems" [required]="formData.recyclingContractOption === 'yes'"
                        [disabled]="formData.recyclingContractOption !== 'yes'"
                        placeholder="e.g., Paper, Cardboard, Plastics, Aluminum cans">
</textarea>

              <!-- Monthly Charge -->
              <label for="recyclingCharge" class="mt-2">
                What is the monthly charge?
              </label>
              <div class="input-group mb-3">
                <span class="input-group-text">$</span>
                <input type="number" id="recyclingCharge" class="form-control" name="recyclingCharge"
                       [(ngModel)]="formData.recyclingCharge" [required]="formData.recyclingContractOption === 'yes'"
                       [disabled]="formData.recyclingContractOption !== 'yes'" placeholder="0.00" min="0" step="0.01">
              </div>

              <!-- Textile Recycling -->
              <label class="mt-3">
                If your school recycles Textiles:
              </label>
              <div class="row g-2 mb-3">
                <div class="col-md-6">
                  <label for="textileMoney">Money earned ($)</label>
                  <input type="number" id="textileMoney" class="form-control" name="textileMoney"
                         [(ngModel)]="formData.textileMoney" [disabled]="formData.recyclingContractOption !== 'yes'"
                         placeholder="Enter amount earned" min="0" step="0.01">
                </div>
                <div class="col-md-6">
                  <label for="textileLbs">Total lbs. collected</label>
                  <input type="number" id="textileLbs" class="form-control" name="textileLbs"
                         [(ngModel)]="formData.textileLbs" [disabled]="formData.recyclingContractOption !== 'yes'"
                         placeholder="Enter total lbs." min="0" step="1">
                </div>
              </div>
            </div>

          </div>

          <!-- STEP 10: Solar -->
          <div *ngIf="activeSteps.includes(10)" class="wizard-step">
            <h3>Solar</h3>
            <div class="mt-3">
              <label for="solarInstructionComment">Describe solar system and how it is used for instruction:</label>
              <textarea id="solarInstructionComment" name="solarInstructionComment"
                        [(ngModel)]="formData.solarInstructionComment" maxlength="200" class="form-control mb-2"
                        placeholder="Enter comment (max 200 characters)"></textarea>
            </div>
            <div class="mt-3">
              <label for="solarUtilityComment">How is solar power utilized for school utilities?</label>
              <textarea id="solarUtilityComment" name="solarUtilityComment" [(ngModel)]="formData.solarUtilityComment"
                        maxlength="200" class="form-control"
                        placeholder="Enter comment (max 200 characters)"></textarea>
            </div>
          </div>

          <!-- Bring One for the Chipper -->
          <div *ngIf="activeSteps.includes(11)" class="wizard-step">
            <h3>Bring One for the Chipper - Christmas Tree Recycling</h3>
            <div class="mt-3">
              <label for="chipperDate">Event Date:</label>
              <input type="date" id="chipperDate" name="chipperDate" class="form-control mb-2"
                     [(ngModel)]="formData.chipperDate" style="max-width: 10rem"/>
            </div>

            <div class="mt-3">
              <label for="chipperResults">Results:</label>
              <textarea id="chipperResults" name="chipperResults" [(ngModel)]="formData.chipperResults"
                        maxlength="100"
                        class="form-control" placeholder="Enter results (max 100 characters)"></textarea>
            </div>
          </div>

          <div *ngIf="activeSteps.includes(12) && formData.sharetable1" class="wizard-step">
            <h3>Share Table</h3>
            <label>Is this operated for Breakfast?</label>
            <div class="d-flex mb-2">
              <div>
                <input type="radio" id="shareTableBreakfastYes" name="shareTableBreakfast" value="yes"
                       [(ngModel)]="formData.shareTableBreakfast">
                <label for="shareTableBreakfastYes">Yes</label>
              </div>
              <div class="ms-3">
                <input type="radio" id="shareTableBreakfastNo" name="shareTableBreakfast" value="no"
                       [(ngModel)]="formData.shareTableBreakfast">
                <label for="shareTableBreakfastNo">No</label>
              </div>
            </div>
            <label>Is this operated for Lunch?</label>
            <div class="d-flex mb-2">
              <div>
                <input type="radio" id="shareTableLunchYes" name="shareTableLunch" value="yes"
                       [(ngModel)]="formData.shareTableLunch">
                <label for="shareTableLunchYes">Yes</label>
              </div>
              <div class="ms-3">
                <input type="radio" id="shareTableLunchNo" name="shareTableLunch" value="no"
                       [(ngModel)]="formData.shareTableLunch">
                <label for="shareTableLunchNo">No</label>
              </div>
            </div>
            <label for="shareTableCommonItems">Common items:</label>
            <textarea id="shareTableCommonItems" name="shareTableCommonItems"
                      [(ngModel)]="formData.shareTableCommonItems"
                      maxlength="200" class="form-control" placeholder="List common items (max 200 characters)">
            </textarea>

          </div>

          <!--Food Pantry DONE-->
          <div *ngIf="activeSteps.includes(13) && formData.pantry" class="wizard-step">
            <h3>Food Pantry</h3>
            <div>
              <label>Food items from:</label>
              <div *ngFor="let items of foodPantryItemsOptions">
                <input
                  type="checkbox"
                  [value]="items"
                  (change)="toggleArrayValue(formData.foodItemsFrom, items, $event)"
                />
                {{ items }}
              </div>
            </div>

            <div class="mt-3">
              <label for="donorName">Enter Donor name:</label>
              <input type="text" id="donorName" name="donorName" [(ngModel)]="formData.donorName" maxlength="50"
                     class="form-control" placeholder="Enter donor name (max 50 characters)"/>
            </div>

            <div class="mt-3">
              <label for="familiesServedAnnually">
                How many families were served annually?
              </label>
              <input type="number" id="familiesServedAnnually" name="familiesServedAnnually"
                     [(ngModel)]="formData.familiesServedAnnually" class="form-control"
                     placeholder="Enter number of families"
                     min="0"/>
            </div>

          </div>

          <!-- STEP 14: Food Waste Audit -->
          <div *ngIf="activeSteps.includes(14) && formData.fwasteaudit" class="wizard-step">
            <h3>Food Waste Audit</h3>
            <!-- Basic Audit Information -->
            <label for="fwaAuditDate">Date of Audit:</label>
            <input type="date" id="fwaAuditDate" name="fwaAuditDate" class="form-control mb-3"
                   [(ngModel)]="formData.fwaAuditDate" required>

            <label for="fwaStudentsServed" class="me-2">Number of Students/Lunches Served:</label>
            <input type="number" id="fwaStudentsServed" name="fwaStudentsServed" class="form-control mb-3"
                   [(ngModel)]="formData.fwaStudentsServed" (input)="calculateFoodWastePerStudent()" min="0" max="9999"
                   style="max-width: 8rem;" required>

            <label for="fwaMenuItems">Menu Items:</label>
            <small class="text-muted d-block mb-1">List what was served today</small>
            <textarea id="fwaMenuItems" name="fwaMenuItems" class="form-control mb-3" rows="2" maxlength="100"
                      [(ngModel)]="formData.fwaMenuItems" placeholder="e.g., Pizza, green beans, milk, apple"
                      required></textarea>
            <small class="text-muted">{{ formData.fwaMenuItems?.length || 0 }}/100 characters</small>

            <!-- Recoverable Items -->
            <label for="fwaRecoverableItemsList" class="mt-3">List Each Recoverable Item Type and Counts:</label>
            <small class="text-muted d-block mb-1">Example: "25 oranges, 35 cheese sticks, 18 unopened milks"</small>
            <textarea id="fwaRecoverableItemsList" name="fwaRecoverableItemsList" class="form-control mb-3" rows="3"
                      maxlength="250" [(ngModel)]="formData.fwaRecoverableItemsList" required></textarea>
            <small class="text-muted">{{ formData.fwaRecoverableItemsList?.length || 0 }}/250 characters</small>

            <!-- Food Waste Weight Data -->
            <h5 class="mt-4 mb-3">Food Waste Data (in pounds):</h5>

            <label for="fwaRecoverables" class="me-2">Recoverables in lbs (unpeeled/unopened):</label>
            <input type="number" id="fwaRecoverables" name="fwaRecoverables" class="form-control mb-3"
                   [(ngModel)]="formData.fwaRecoverables" (input)="calculateTotalFoodWaste()" min="0" step="0.1"
                   style="max-width: 8rem;" required >

            <label for="fwaMilk" class="me-2">Milk lbs:</label>
            <input type="number" id="fwaMilk" name="fwaMilk" class="form-control mb-3" [(ngModel)]="formData.fwaMilk"
                   (input)="calculateTotalFoodWaste()" min="0" step="0.1" style="max-width: 8rem;" required
                   >

            <label for="fwaOtherLiquids" class="me-2">Other Liquids lbs:</label>
            <input type="number" id="fwaOtherLiquids" name="fwaOtherLiquids" class="form-control mb-3"
                   [(ngModel)]="formData.fwaOtherLiquids" (input)="calculateTotalFoodWaste()" min="0" step="0.1"
                   style="max-width: 8rem;" required >

            <label for="fwaFruitsVegetables" class="me-2">Fruits and Vegetables lbs:</label>
            <input type="number" id="fwaFruitsVegetables" name="fwaFruitsVegetables" class="form-control mb-3"
                   [(ngModel)]="formData.fwaFruitsVegetables" (input)="calculateTotalFoodWaste()" min="0" step="0.1"
                   style="max-width: 8rem;" required >

            <label for="fwaMeatsGrainsOther" class="me-2">All Other (meats, grains, other) lbs:</label>
            <input type="number" id="fwaMeatsGrainsOther" name="fwaMeatsGrainsOther" class="form-control mb-3"
                   [(ngModel)]="formData.fwaMeatsGrainsOther" (input)="calculateTotalFoodWaste()" min="0" step="0.1"
                   style="max-width: 8rem;" required >

            <!-- Auto-calculated totals -->
            <div class="mt-3 p-3 bg-light border rounded">
              <label class="me-2"><strong>Total Lbs of Food Waste:</strong></label>
              <span class="fs-5 text-primary">{{ formData.fwaTotalFoodWaste || 0 }} lbs</span>
              <small class="text-muted d-block">Auto-calculated</small>

              <label class="me-2 mt-2"><strong>Lbs of Food Waste Per Student:</strong></label>
              <span class="fs-5 text-primary">{{ formData.fwaFoodWastePerStudent || 0 }} lbs</span>
              <small class="text-muted d-block">Auto-calculated (Total ÷ Students Served)</small>
            </div>

            <!-- Non-Food Waste -->
            <h5 class="mt-4 mb-3">Non-Food Waste Data (in pounds):</h5>

            <label for="fwaTrashPackaging" class="me-2">Trash/Packaging lbs:</label>
            <input type="number" id="fwaTrashPackaging" name="fwaTrashPackaging" class="form-control mb-3"
                   [(ngModel)]="formData.fwaTrashPackaging" min="0" step="0.1" style="max-width: 8rem;" required
                   >

            <label for="fwaRecycling" class="me-2">Recycling lbs:</label>
            <input type="number" id="fwaRecycling" name="fwaRecycling" class="form-control mb-3"
                   [(ngModel)]="formData.fwaRecycling" min="0" step="0.1" style="max-width: 8rem;" required
                   >

            <!-- Audit Participation -->
            <h5 class="mt-4 mb-3">Audit Participation:</h5>

            <label for="fwaParentHelpers" class="me-2">Number of Parent Helpers:</label>
            <input type="number" id="fwaParentHelpers" name="fwaParentHelpers" class="form-control mb-3"
                   [(ngModel)]="formData.fwaParentHelpers" min="0" style="max-width: 5rem;" required >

            <label for="fwaStudentsParticipating" class="me-2">Number of Students Participating in Audit:</label>
            <input type="number" id="fwaStudentsParticipating" name="fwaStudentsParticipating" class="form-control mb-3"
                   [(ngModel)]="formData.fwaStudentsParticipating" min="0" style="max-width: 5rem;" required
                   >

            <label for="fwaCommunityMembers" class="me-2">Number of Community Members:</label>
            <input type="number" id="fwaCommunityMembers" name="fwaCommunityMembers" class="form-control mb-3"
                   [(ngModel)]="formData.fwaCommunityMembers" min="0" style="max-width: 5rem;" required >

            <label for="fwaCommunityMembersIdentify">Identify Community Members:</label>
            <textarea id="fwaCommunityMembersIdentify" name="fwaCommunityMembersIdentify" class="form-control mb-3"
                      rows="2" maxlength="100" [(ngModel)]="formData.fwaCommunityMembersIdentify"
                      placeholder="List names/organizations"></textarea>
            <small class="text-muted">{{ formData.fwaCommunityMembersIdentify?.length || 0 }}/100 characters</small>

            <!-- Student Feedback & Analysis -->
            <h5 class="mt-4 mb-3">Commentary & Analysis:</h5>

            <label>Student Feedback - Why was food wasted? <small class="text-muted">(select all that
              apply)</small></label>

            <div class="form-check mb-2" *ngFor="let option of studentFeedbackOptions">
              <input
                class="form-check-input"
                type="checkbox"
                [value]="option"
                [checked]="formData.fwaStudentFeedback?.includes(option)"
                (change)="toggleFeedback(option, $event)"
              />
              <label class="form-check-label">{{ option }}</label>
            </div>


            <!-- First Audit Question -->
            <label class="mt-3">Is this your school's first audit this year?</label>
            <div class="d-flex flex-column mb-3">
              <div class="d-flex align-items-center mb-2">
                <input type="radio" id="fwaIsFirstAuditYes" name="fwaIsFirstAudit" [value]="true"
                       [(ngModel)]="formData.fwaIsFirstAudit">
                <label for="fwaIsFirstAuditYes" class="ms-2">Yes</label>
              </div>
              <div class="d-flex align-items-center">
                <input type="radio" id="fwaIsFirstAuditNo" name="fwaIsFirstAudit" [value]="false"
                       [(ngModel)]="formData.fwaIsFirstAudit">
                <label for="fwaIsFirstAuditNo" class="ms-2">No</label>
              </div>
            </div>

            <!-- Conditional: If NOT first audit -->
            <div *ngIf="formData.fwaIsFirstAudit === false">
              <label for="fwaComparisonToPrevious" class="mt-3">How does this audit compare with previous
                results?</label>
              <textarea id="fwaComparisonToPrevious" name="fwaComparisonToPrevious" class="form-control mb-3" rows="2"
                        maxlength="100" [(ngModel)]="formData.fwaComparisonToPrevious"
                        [required]="formData.fwaIsFirstAudit === false"></textarea>

              <label for="fwaWasteAttribution">To what do you attribute the change in food waste?</label>
              <textarea id="fwaWasteAttribution" name="fwaWasteAttribution" class="form-control mb-3" rows="2"
                        maxlength="100" [(ngModel)]="formData.fwaWasteAttribution"
                        [required]="formData.fwaIsFirstAudit === false"></textarea>
            </div>

            <!-- School Food Programs -->
            <h5 class="mt-4 mb-2">School Food Programs:</h5>

            <div class="form-check">
              <input class="form-check-input" type="checkbox" id="fwaShareTableBreakfast" name="fwaShareTableBreakfast"
                     [(ngModel)]="formData.fwaShareTableBreakfast">
              <label class="form-check-label" for="fwaShareTableBreakfast">
                Does your school operate a share table for breakfast?
              </label>
            </div>

            <div class="form-check">
              <input class="form-check-input" type="checkbox" id="fwaShareTableLunch" name="fwaShareTableLunch"
                     [(ngModel)]="formData.fwaShareTableLunch">
              <label class="form-check-label" for="fwaShareTableLunch">
                Does your school operate a share table for lunch?
              </label>
            </div>

            <div class="form-check">
              <input class="form-check-input" type="checkbox" id="fwaShareRefrigerator" name="fwaShareRefrigerator"
                     [(ngModel)]="formData.fwaShareRefrigerator">
              <label class="form-check-label" for="fwaShareRefrigerator">
                Does your school have a share refrigerator?
              </label>
            </div>

            <div class="form-check">
              <input class="form-check-input" type="checkbox" id="fwaFoodPantryOperating" name="fwaFoodPantryOperating"
                     [(ngModel)]="formData.fwaFoodPantryOperating">
              <label class="form-check-label" for="fwaFoodPantryOperating">
                Does your school operate a food pantry?
              </label>
            </div>

            <div class="form-check mb-3">
              <input class="form-check-input" type="checkbox" id="fwaShareTableToFoodPantry"
                     name="fwaShareTableToFoodPantry" [(ngModel)]="formData.fwaShareTableToFoodPantry">
              <label class="form-check-label" for="fwaShareTableToFoodPantry">
                Are share table items delivered to the food pantry at end of lunch?
              </label>
            </div>

            <!-- Solutions Implemented -->
            <label for="fwaSolutionsImplemented" class="mt-3">What solutions have students put in place to reduce food
              waste?</label>
            <small class="text-muted d-block mb-1">e.g., Educational campaigns, composting, diverting to
              chickens/rabbits,
              donation</small>
            <textarea id="fwaSolutionsImplemented" name="fwaSolutionsImplemented" class="form-control mb-3" rows="2"
                      maxlength="100" [(ngModel)]="formData.fwaSolutionsImplemented" required></textarea>

            <!-- Grant Information -->
            <label class="mt-3">Was a grant received or supplies donated by partner organizations?</label>
            <div class="d-flex flex-column mb-3">
              <div class="d-flex align-items-center mb-2">
                <input type="radio" id="fwaGrantReceivedYes" name="fwaGrantReceived" [value]="true"
                       [(ngModel)]="formData.fwaGrantReceived">
                <label for="fwaGrantReceivedYes" class="ms-2">Yes</label>
              </div>
              <div class="d-flex align-items-center">
                <input type="radio" id="fwaGrantReceivedNo" name="fwaGrantReceived" [value]="false"
                       [(ngModel)]="formData.fwaGrantReceived">
                <label for="fwaGrantReceivedNo" class="ms-2">No</label>
              </div>
            </div>

            <!-- Conditional: Grant Value -->
            <div *ngIf="formData.fwaGrantReceived" class="mb-3">
              <label for="fwaGrantValue" class="me-2">Value of Grant or Supplies Received ($):</label>
              <div class="input-group" style="max-width: 12rem;">
                <span class="input-group-text">$</span>
                <input type="number" id="fwaGrantValue" name="fwaGrantValue" class="form-control"
                       [(ngModel)]="formData.fwaGrantValue" min="0" step="0.01" [required]="formData.fwaGrantReceived">
              </div>
            </div>

          </div>

          <!--Fish Hatchery-->
          <div *ngIf="activeSteps.includes(15) && formData.fish" class="wizard-step">
            <h3>Fish Hatchery</h3>
            <div class="section mt-3">
              <div class="mb-3">
                <label for="fishHatcheryNumReleased" class="form-label">
                  Appx number of fish released:
                </label>
                <input type="number" id="fishHatcheryNumReleased" name="fishHatcheryNumReleased"
                       [(ngModel)]="formData.fishHatcheryNumReleased" class="form-control" min="0"
                       placeholder="Enter number"/>
              </div>

              <div class="mb-3">
                <label for="fishHatcheryTypeComment" class="form-label">
                  Type of fish - comment:
                </label>
                <input type="text" id="fishHatcheryTypeComment" name="fishHatcheryTypeComment"
                       [(ngModel)]="formData.fishHatcheryTypeComment" maxlength="50" class="form-control"
                       placeholder="Enter comment (max 50 characters)"/>
              </div>
            </div>
          </div>

          <!-- 16 is done -->
          <div *ngIf="activeSteps.includes(16) && formData.chicken" class="wizard-step">
            <h3>Chickens and Other Farm Animals – Goats, Rabbits, Other</h3>
            <div class="section mt-3">
              <div class="mb-3">
                <label class="form-label">Were students/families provided eggs?</label>
                <div>
                  <label class="me-3">
                    <input type="radio" name="eggsProvided" value="yes" [(ngModel)]="formData.eggsProvided"/>
                    Yes
                  </label>
                  <label>
                    <input type="radio" name="eggsProvided" value="no" [(ngModel)]="formData.eggsProvided"/>
                    No
                  </label>
                </div>
              </div>
              <div *ngIf="formData.eggsProvided === 'yes'">
                <div class="mb-3">
                  <label for="familiesServedEggs" class="form-label">
                    If so, how many families were served with eggs?
                  </label>
                  <input type="number" id="familiesServedEggs" name="familiesServedEggs"
                         [(ngModel)]="formData.familiesServedEggs" class="form-control" min="0"
                         placeholder="Enter number of families"/>

                </div>
                <div class="mb-3">
                  <label for="lbsEggsDonated" class="form-label">
                    Approx. how many lbs. of eggs was donated?
                  </label>
                  <input type="number" id="lbsEggsDonated" name="lbsEggsDonated" [(ngModel)]="formData.lbsEggsDonated"
                         class="form-control" min="0" placeholder="Enter lbs of eggs donated"/>
                </div>
              </div>

            </div>
          </div>

          <div *ngIf="activeSteps.includes(17) && formData.class" class="wizard-step">
            <h3>Outdoor Classroom/Gazebos/seating</h3>
            <div class="section mt-3">
              <!-- Number of garden learning areas -->
              <div class="mb-3">
                <label for="numGardenLearningAreas" class="form-label">
                  Number of garden learning areas:
                </label>
                <input type="number" id="numGardenLearningAreas" name="numGardenLearningAreas"
                       [(ngModel)]="formData.numGardenLearningAreas" class="form-control" min="0"
                       placeholder="Enter number of garden areas"/>
              </div>
            </div>
            <!-- Size of garden -->
            <div class="mb-3">
              <label for="sizeOfGarden" class="form-label">
                Size of garden:
              </label>
              <input type="text" id="sizeOfGarden" name="sizeOfGarden" [(ngModel)]="formData.sizeOfGarden"
                     class="form-control" maxlength="100" placeholder="Enter approximate size (max 100 characters)"/>
            </div>
          </div>

          <div *ngIf="activeSteps.includes(18) && formData.trails" class="wizard-step">
            <h3>Trails / Forested Area</h3>
            <div class="section mt-3">
              <div>
                <label for="trailDescription">Describe trails/forested area created:</label>
              </div>
              <div>
                <input type="text" id="trailDescription" name="trailDescription" [(ngModel)]="formData.trailDescription"
                       maxlength="100" class="form-control" placeholder="Enter description (max 100 characters)"/>
              </div>
            </div>
          </div>

          <!-- Paper & Cardboard -->
          <div *ngIf="activeSteps.includes(19) && formData.paperAndCardboard" class="wizard-step">
            <h3>Paper & Cardboard</h3>
            <div class="mt-2">
              <label for="paperAndCardboardLbs">
                Lbs of Paper & Cardboard collected for recycling:
              </label>
              <input type="number" id="paperAndCardboardLbs" name="paperAndCardboardLbs"
                     [(ngModel)]="formData.paperCardboardLbs" placeholder="Enter number of pounds"
                     class="form-control" style="max-width: 5rem;"/>
            </div>

            <!-- Hauler / company name -->
            <div class="mt-2">
              <label for="paperAndCardboardCompany">
                Paper/Cardboard Hauler/Company Name:
              </label>
              <input type="text" id="paperAndCardboardCompany" name="paperAndCardboardCompany"
                     [(ngModel)]="formData.paperAndCardboardCompany" maxlength="50"
                     placeholder="Enter company name (max 50 characters)" class="form-control"/>
            </div>

            <div class="mt-2">
              <label for="paperAndCardboardCost">Paper/Cardboard Monthly Cost ($):</label>
              <input type="number" id="paperAndCardboardCost" name="paperAndCardboardCost"
                     [(ngModel)]="formData.paperAndCardboardCost" class="form-control" style="max-width: 5rem;"/>
            </div>
          </div>

          <!-- Educational Campaign -->
          <div *ngIf="activeSteps.includes(20) && formData.educationalcampaign1" class="wizard-step">
            <h3>Educational Campaign</h3>
            <div class="mt-2">
              <label for="campaignContentComment">
                Detail Content included comment (Poster, A.M. Announcement, Video, etc – upload examples)
                (text 200 characters):
              </label>
              <textarea id="campaignContentComment" name="campaignContentComment" maxlength="200"
                        [(ngModel)]="formData.campaignContentComment" rows="3" class="form-control"></textarea>
            </div>


          </div>

          <div *ngIf="activeSteps.includes(21) && formData.greenhouse" class="wizard-step">
            <div class="section mt-3">
              <h3>Greenhouse(s)</h3>
              <label for="greenhouseComment">
                Green House Comment (max 100 characters):
              </label>

              <input type="text" id="greenhouseComment" maxlength="100" [(ngModel)]="formData.greenhouseComment"
                     class="form-control"/>
            </div>
          </div>

          <!-- Composting System-->
          <div *ngIf="activeSteps.includes(22) && formData.compostSystem" class="wizard-step">
            <h3>Composting System</h3>
            <label for="gardenScrapsLbs">Number of pounds of garden scraps composted:</label>
            <input type="number" id="gardenScrapsLbs" [(ngModel)]="formData.gardenScrapsCompostedLbs"
                   class="form-control"
                   min="0"/>
          </div>

          <!-- Southeast Pollinator Census -->
          <div *ngIf="activeSteps.includes(23) && formData.pollinatorCensus" class="wizard-step">
            <h3>Southeast Pollinator Census</h3>
            <!-- Appx number -->
            <div class="mt-3">
              <label for="pollinatorCountApprox">Appx number of pollinators counted:</label>
              <input type="number" id="pollinatorCountApprox" min="0" [(ngModel)]="formData.pollinatorCountApprox"
                     class="form-control"/>
            </div>

            <!-- Comparison -->
            <div class="mt-3">
              <label for="pollinatorComparisonComment">How did results compare to prior years? (max 100 chars)</label>
              <input type="text" id="pollinatorComparisonComment" maxlength="100"
                     [(ngModel)]="formData.pollinatorComparisonComment" class="form-control"/>
            </div>

            <br>

            <input type="checkbox" id="pollinatorOther" [(ngModel)]="formData.pollinatorOther">

            <label for="pollinatorOther">Other – enter comment below</label>

            <!-- MUST BE DIRECT SIBLING -->
            <div class="other-text">
              <label>Other Outdoor Learning Comment:</label>
              <input type="text" maxlength="100" [(ngModel)]="formData.pollinatorOtherComment" class="form-control">
            </div>


          </div>

          <div *ngIf="activeSteps.includes(24)" class="wizard-step">
            <h4>Water Education</h4>
            <label for="waterTopics">List the water-related topics your project covered, if any:</label>
            <textarea id="waterTopics" name="waterTopics" class="form-control mb-3" required
                      [(ngModel)]="formData.waterTopics"></textarea>

            <label for="waterProjectDescription">Describe the water-related project:</label>
            <textarea id="waterProjectDescription" name="waterProjectDescription" class="form-control mb-3" required
                      [(ngModel)]="formData.waterProjectDescription"></textarea>


            <label for="numHoursInWater" class="me-2">Approximately how many total hours were students engaged in the
              activity?</label>
            <input type="number" [(ngModel)]="formData.numHoursInWater" class="form-control" name="numHoursInWater"
                   id="numHoursInWater" min="0" max="9999" style="max-width: 5rem;" #numHoursInWater="ngModel"
                   [ngClass]="{'is-invalid': numHoursInWater.invalid && numHoursInWater.touched}" required
                   appIntegerInput>
            <small id="numHoursInWaterTip" class="form-text text-muted mb-3">
              Total time = number of students * number of hours
            </small>

          </div>

          <!-- 25 – Watershed Educational Campaign -->
          <div *ngIf="activeSteps.includes(25) && formData.waterEducationalCampaign" class="wizard-step">
            <h3>Water Educational Campaign</h3>
            <label for="watershedEduDetail">
              Detail Content included comment (Poster, Printed Materials, Video, etc – upload examples)
              (text 250 characters):
            </label>
            <textarea id="watershedEduDetail" name="watershedEduDetail" maxlength="250"
                      [(ngModel)]="formData.watershedEduDetail" class="form-control mb-3"></textarea>

            <!-- Campaign targeted to students/youth -->
            <label class="mt-3">Campaign targeted to students/youth?</label>
            <div class="d-flex mb-3">
              <div class="form-check me-3">
                <input class="form-check-input" type="radio" name="watershedEduTargetStudents"
                       id="watershedEduTargetStudentsYes" [value]="true"
                       [(ngModel)]="formData.watershedEduTargetStudents">
                <label class="form-check-label" for="watershedEduTargetStudentsYes">Yes</label>
              </div>
              <div class="form-check">
                <input class="form-check-input" type="radio" name="watershedEduTargetStudents"
                       id="watershedEduTargetStudentsNo" [value]="false"
                       [(ngModel)]="formData.watershedEduTargetStudents">
                <label class="form-check-label" for="watershedEduTargetStudentsNo">No</label>
              </div>
            </div>

            <!-- Campaign targeted to parents/community -->
            <label>Campaign targeted to parents/community?</label>
            <div class="d-flex mb-3">
              <div class="form-check me-3">
                <input class="form-check-input" type="radio" name="watershedEduTargetParents"
                       id="watershedEduTargetParentsYes" [value]="true"
                       [(ngModel)]="formData.watershedEduTargetParents">
                <label class="form-check-label" for="watershedEduTargetParentsYes">Yes</label>
              </div>
              <div class="form-check">
                <input class="form-check-input" type="radio" name="watershedEduTargetParents"
                       id="watershedEduTargetParentsNo" [value]="false"
                       [(ngModel)]="formData.watershedEduTargetParents">
                <label class="form-check-label" for="watershedEduTargetParentsNo">No</label>
              </div>
            </div>
          </div>

          <!-- 26 – Adopt-A-Road -->
          <div *ngIf="activeSteps.includes(26) && formData.adoptARoadWatershed" class="wizard-step">
            <h3>Adopt-A-Road</h3>
            <label for="watershedRoadName">Name of Road (text 50 characters):</label>
            <input id="watershedRoadName" name="watershedRoadName" maxlength="50"
                   [(ngModel)]="formData.watershedRoadName" class="form-control mb-3"/>

            <label for="watershedRoadTrashLbs">Lbs. of trash collected (# input):</label>
            <input id="watershedRoadTrashLbs" name="watershedRoadTrashLbs" type="number" min="0"
                   [(ngModel)]="formData.watershedRoadTrashLbs" class="form-control mb-3"/>
          </div>

          <!-- 27 – Adopt-A-Stream Clean-up -->
          <div *ngIf="activeSteps.includes(27) && formData.adoptAStreamCleanup" class="wizard-step">
            <h3>Adopt-A-Stream Clean-up</h3>
            <label for="watershedStreamCleanupName">Name of Stream (text 50 characters):</label>
            <input id="watershedStreamCleanupName" name="watershedStreamCleanupName" maxlength="50"
                   [(ngModel)]="formData.watershedStreamCleanupName" class="form-control mb-3"/>

            <label for="watershedStreamCleanupLbs">Lbs. of trash/debris collected (# input):</label>
            <input id="watershedStreamCleanupLbs" name="watershedStreamCleanupLbs" type="number" min="0"
                   [(ngModel)]="formData.watershedStreamCleanupLbs" class="form-control mb-3"/>
          </div>

          <!-- 28 – Adopt-A-Stream Monitoring -->
          <div *ngIf="activeSteps.includes(28) && formData.adoptAStreamMonitoring" class="wizard-step">
            <h3>Adopt-A-Stream Monitoring</h3>
            <div class="form-check">
              <input class="form-check-input" type="checkbox" id="watershedMonitorBiological"
                     [(ngModel)]="formData.watershedMonitorBiological">
              <label class="form-check-label" for="watershedMonitorBiological">
                Biological (macroinvertebrates)
              </label>
            </div>

            <div class="form-check">
              <input class="form-check-input" type="checkbox" id="watershedMonitorChemical"
                     [(ngModel)]="formData.watershedMonitorChemical">
              <label class="form-check-label" for="watershedMonitorChemical">
                Chemical (pH, BOD, DO, Turbidity)
              </label>
            </div>

            <div class="form-check">
              <input class="form-check-input" type="checkbox" id="watershedMonitorOther"
                     [(ngModel)]="formData.watershedMonitorOther">
              <label class="form-check-label" for="watershedMonitorOther">
                Other – enter comment below
              </label>
            </div>

            <input id="watershedMonitorOtherComment" name="watershedMonitorOtherComment" maxlength="50"
                   [(ngModel)]="formData.watershedMonitorOtherComment"
                   class="form-control mb-3" placeholder="Other monitoring type (max 50 chars)"/>

            <label for="watershedMonitorStreamName">Name of AAR Stream (text 50 characters):</label>
            <input id="watershedMonitorStreamName" name="watershedMonitorStreamName" maxlength="50"
                   [(ngModel)]="formData.watershedMonitorStreamName" class="form-control mb-3"/>
          </div>

          <!-- 29 – Stream Restoration/Erosion Control -->
          <div *ngIf="activeSteps.includes(29) && formData.streamRestoration" class="wizard-step">
            <h3>Stream Restoration/Erosion Control</h3>
            <label for="watershedRestorationStreamName">
              Name of Restoration/Erosion Control Stream (text 50 characters):
            </label>
            <input id="watershedRestorationStreamName" name="watershedRestorationStreamName" maxlength="50"
                   [(ngModel)]="formData.watershedRestorationStreamName" class="form-control mb-3"/>
          </div>

          <!-- Waste Water Plant -->
          <div *ngIf="activeSteps.includes(30) && formData.wasteWaterPlant" class="wizard-step">
            <h3>Waste Water Plant</h3>
            <label for="wasteWaterPlantComment">Result Commentary (text 200 characters):</label>
            <textarea id="wasteWaterPlantComment" name="wasteWaterPlantComment" maxlength="200"
                      [(ngModel)]="formData.wasteWaterPlantComment"
                      class="form-control mb-3"></textarea>
          </div>

          <!-- Drinking Water Plant -->
          <div *ngIf="activeSteps.includes(31) && formData.drinkingWaterPlant" class="wizard-step">
            <h3>Drinking Water Plant</h3>
            <label for="drinkingWaterPlantComment">Result Commentary (text 200 characters):</label>
            <textarea id="drinkingWaterPlantComment" name="drinkingWaterPlantComment" maxlength="200"
                      [(ngModel)]="formData.drinkingWaterPlantComment"
                      class="form-control mb-3"></textarea>
          </div>

          <!-- The Water Tower -->
          <div *ngIf="activeSteps.includes(32) && formData.theWaterTower" class="wizard-step">
            <h3>The Water Tower</h3>
            <label for="waterTowerComment">Result Commentary (text 200 characters):</label>
            <textarea id="waterTowerComment" name="waterTowerComment" maxlength="200"
                      [(ngModel)]="formData.waterTowerComment"
                      class="form-control mb-3"></textarea>
          </div>

          <!-- Dept of Water Resources -->
          <div *ngIf="activeSteps.includes(33) && formData.deptOfWaterResources" class="wizard-step">
            <h3>Dept of Water Resources</h3>
            <label for="deptOfWaterResourcesComment">Result Commentary (text 200 characters):</label>
            <textarea id="deptOfWaterResourcesComment" name="deptOfWaterResourcesComment" maxlength="200"
                      [(ngModel)]="formData.deptOfWaterResourcesComment"
                      class="form-control mb-3"></textarea>
          </div>

          <!-- Gwinnett Clean & Beautiful -->
          <div *ngIf="activeSteps.includes(34) && formData.gwinnettCleanBeautiful" class="wizard-step">
            <h3>Gwinnett Clean & Beautiful</h3>
            <label for="gwinnettCleanBeautifulComment">Result Commentary (text 200 characters):</label>
            <textarea id="gwinnettCleanBeautifulComment" name="gwinnettCleanBeautifulComment" maxlength="200"
                      [(ngModel)]="formData.gwinnettCleanBeautifulComment"
                      class="form-control mb-3"></textarea>
          </div>

          <!-- STEP 35: Watershed Field Trip - Other -->
          <div *ngIf="activeSteps.includes(35)" class="wizard-step">
            <label for="watershedOtherTripComment">Result Commentary (text 200 characters):</label>
            <small class="text-muted d-block mb-1">Describe the field trip, participation, and learning outcomes</small>
            <textarea id="watershedOtherTripComment" name="watershedOtherTripComment" maxlength="200"
                      [(ngModel)]="formData.watershedOtherTripComment"
                      rows="3" class="form-control mb-3"
                      placeholder="Detail field trip location, activities, and key learnings"></textarea>
            <small class="text-muted">{{ formData.watershedOtherTripComment.length || 0 }}/200 characters</small>
          </div>

          <!--GC&B Great Days of Service-->
          <div *ngIf="activeSteps.includes(36) && formData.greatDaysService" class="wizard-step">
            <h3>GC&B Great Days of Service</h3>
            <label for="greatDaysServiceComment">Result Commentary (text 200 characters):</label>
            <small class="text-muted d-block mb-1">Describe participation, results, and outcomes</small>
            <textarea id="greatDaysServiceComment" name="greatDaysServiceComment" maxlength="200"
                      [(ngModel)]="formData.greatDaysServiceComment"
                      rows="3" class="form-control mb-3"
                      placeholder="Detail activities, participation numbers, and outcomes"></textarea>
            <small class="text-muted">{{ formData.greatDaysServiceComment.length || 0 }}/200 characters</small>
          </div>

          <!-- STEP 37: GC&B Wetland Cleanup -->
          <div *ngIf="activeSteps.includes(37) && formData.wetlandCleanup" class="wizard-step">
            <h3>GC&B Wetland Cleanup</h3>
            <label for="wetlandCleanupComment">Result Commentary (text 200 characters):</label>
            <small class="text-muted d-block mb-1">Describe participation, results, and outcomes</small>
            <textarea id="wetlandCleanupComment" name="wetlandCleanupComment" maxlength="200"
                      [(ngModel)]="formData.wetlandCleanupComment"
                      rows="3" class="form-control mb-3"
                      placeholder="Detail activities, participation numbers, and outcomes"></textarea>
            <small class="text-muted">{{ formData.wetlandCleanupComment.length || 0 }}/200 characters</small>
          </div>

          <!-- STEP 38: Yellow River Trash Bash -->
          <div *ngIf="activeSteps.includes(38) && formData.yellowRiverTrashBash" class="wizard-step">
            <h3>Yellow River Trash Bash</h3>
            <label for="yellowRiverTrashBashComment">Result Commentary (text 200 characters):</label>
            <small class="text-muted d-block mb-1">Describe participation, results, and outcomes</small>
            <textarea id="yellowRiverTrashBashComment" name="yellowRiverTrashBashComment" maxlength="200"
                      [(ngModel)]="formData.yellowRiverTrashBashComment"
                      rows="3" class="form-control mb-3"
                      placeholder="Detail activities, participation numbers, and outcomes"></textarea>
            <small class="text-muted">{{ formData.yellowRiverTrashBashComment.length || 0 }}/200 characters</small>
          </div>

          <!-- STEP 39: Shore Sweep -->
          <div *ngIf="activeSteps.includes(39) && formData.shoreSweep" class="wizard-step">
            <h3>Shore Sweep</h3>
            <label for="shoreSweepComment">Result Commentary (text 200 characters):</label>
            <small class="text-muted d-block mb-1">Describe participation, results, and outcomes</small>
            <textarea id="shoreSweepComment" name="shoreSweepComment" maxlength="200"
                      [(ngModel)]="formData.shoreSweepComment"
                      rows="3" class="form-control mb-3"
                      placeholder="Detail activities, participation numbers, and outcomes"></textarea>
            <small class="text-muted">{{ formData.shoreSweepComment.length || 0 }}/200 characters</small>
          </div>

          <!-- STEP 40: Local Water Event -->
          <div *ngIf="activeSteps.includes(40) && formData.localWaterEvent" class="wizard-step">
            <h3>Other Local Water-Related Event</h3>
            <label for="localWaterEventComment2">Result Commentary (text 200 characters):</label>
            <small class="text-muted d-block mb-1">Describe the event, participation, results, and outcomes</small>
            <textarea id="localWaterEventComment2" name="localWaterEventComment2" maxlength="200"
                      [(ngModel)]="formData.localWaterEventComment2"
                      rows="3" class="form-control mb-3"
                      placeholder="Detail event name, activities, participation numbers, and outcomes"></textarea>
            <small class="text-muted">{{ formData.localWaterEventComment2.length || 0 }}/200 characters</small>
          </div>

          <!-- STEP 41: Other Gwinnett County Service Dept -->
          <div *ngIf="activeSteps.includes(41) && formData.gwinnettServiceDept" class="wizard-step">
            <h3>Other Gwinnett County Service Dept</h3>
            <label for="gwinnettServiceDeptComment">Result Commentary (text 200 characters):</label>
            <small class="text-muted d-block mb-1">Describe participation, results, and outcomes</small>
            <textarea id="gwinnettServiceDeptComment" name="gwinnettServiceDeptComment" maxlength="200"
                      [(ngModel)]="formData.gwinnettServiceDeptComment"
                      rows="3" class="form-control mb-3"
                      placeholder="Detail activities, participation numbers, and outcomes"></textarea>
            <small class="text-muted">{{ formData.gwinnettServiceDeptComment.length || 0 }}/200 characters</small>
          </div>

          <!-- STEP 42: Support Local Charity or Non-Profit -->
          <div *ngIf="activeSteps.includes(42) && formData.supportCharity" class="wizard-step">
            <h3>Support Local Charity or Non-Profit</h3>
            <label for="supportCharityComment">Result Commentary (text 200 characters):</label>
            <small class="text-muted d-block mb-1">Describe the charity/non-profit, participation, results, and
              outcomes</small>
            <textarea id="supportCharityComment" name="supportCharityComment" maxlength="200"
                      [(ngModel)]="formData.supportCharityComment"
                      rows="3" class="form-control mb-3"
                      placeholder="Detail charity name, activities, participation numbers, and outcomes"></textarea>
            <small class="text-muted">{{ formData.supportCharityComment.length || 0 }}/200 characters</small>
          </div>

          <!-- STEP 43: Other Student or School-Led Projects
          <div *ngIf="activeSteps.includes(43) && formData." class="wizard-step">
            <h3>Other Student or School-Led Projects</h3>
            <label for="studentProjectsComment">Result Commentary (text 200 characters):</label>
            <small class="text-muted d-block mb-1">Describe the projects, participation, results, and outcomes</small>
            <textarea id="studentProjectsComment" name="studentProjectsComment" maxlength="200"
                      [(ngModel)]="formData.studentProjectsComment"
                      rows="3" class="form-control mb-3"
                      placeholder="Detail project activities, participation numbers, and outcomes"></textarea>
            <small class="text-muted">{{ formData.studentProjectsComment.length || 0 }}/200 characters</small>
          </div>-->

          <div *ngIf="activeSteps.includes(44) && formData.hydroponics1" class="wizard-step">
            <h3>Hydroponics</h3>
            <div class="mt-3">
              <label for="hydroponicsSystemDescription">Describe your growing system:</label>
              <input id="hydroponicsSystemDescription" name="hydroponicsSystemDescription" maxlength="100"
                     [(ngModel)]="formData.hydroponicsSystemDescription" class="form-control mb-3"/>
            </div>

            <div class="mt-3">
              <label for="hydroponicsItemsGrown">Items grown:</label>
              <input id="hydroponicsItemsGrown" name="hydroponicsItemsGrown" maxlength="100"
                     [(ngModel)]="formData.hydroponicsItemsGrown" class="form-control mb-3"/>
            </div>

            <div class="mt-3">
              <label for="hydroponicsFoodDonatedLbs">Pounds of Indoor food grown donated:</label>
              <input type="number" [(ngModel)]="formData.hydroponicsFoodDonatedLbs" class="form-control mb-3"
                     id="hydroponicsFoodDonatedLbs"
                     name="hydroponicsFoodDonatedLbs" min="0" style="max-width: 5rem;"
                     #hydroponicsFoodDonatedLbs="ngModel"
                     appIntegerInput>
            </div>
          </div>

          <div *ngIf="activeSteps.includes(45) && formData.aquaponics1" class="wizard-step">
            <h3>Aquaponics</h3>
            <div class="mt-3">
              <label for="aquaponicsSystemDescription">Describe your growing system:</label>
              <input id="aquaponicsSystemDescription" name="aquaponicsSystemDescription" maxlength="100"
                     [(ngModel)]="formData.aquaponicsSystemDescription" class="form-control mb-3"/>
            </div>

            <div class="mt-3">
              <label for="aquaponicsItemsGrown">Items grown:</label>
              <input id="aquaponicsItemsGrown" name="aquaponicsItemsGrown" maxlength="100"
                     [(ngModel)]="formData.aquaponicsItemsGrown" class="form-control mb-3"/>
            </div>

            <div class="mt-3">
              <label for="aquaponicsFoodDonatedLbs">Pounds of Indoor food grown donated:</label>
              <input type="number" [(ngModel)]="formData.aquaponicsFoodDonatedLbs" class="form-control mb-3"
                     id="aquaponicsFoodDonatedLbs"
                     name="aquaponicsFoodDonatedLbs" min="0" style="max-width: 5rem;"
                     #aquaponicsFoodDonatedLbs="ngModel"
                     appIntegerInput>
            </div>
          </div>

          <div *ngIf="activeSteps.includes(46) && formData.aeroponics1" class="wizard-step">
            <h3>Aeroponics</h3>
            <div class="mt-3">
              <label for="aeroponicsSystemDescription">Describe your growing system:</label>
              <input id="aeroponicsSystemDescription" name="aeroponicsSystemDescription" maxlength="100"
                     [(ngModel)]="formData.aeroponicsSystemDescription" class="form-control mb-3"/>
            </div>

            <div class="mt-3">
              <label for="aeroponicsItemsGrown">Items grown:</label>
              <input id="aeroponicsItemsGrown" name="aeroponicsItemsGrown" maxlength="100"
                     [(ngModel)]="formData.aeroponicsItemsGrown" class="form-control mb-3"/>
            </div>

            <div class="mt-3">
              <label for="aeroponicsFoodDonatedLbs">Pounds of Indoor food grown donated:</label>
              <input type="number" [(ngModel)]="formData.aeroponicsFoodDonatedLbs" class="form-control mb-3"
                     id="aeroponicsFoodDonatedLbs"
                     name="aquaponicsFoodDonatedLbs" min="0" style="max-width: 5rem;"
                     #aeroponicsFoodDonatedLbs="ngModel"
                     appIntegerInput>
            </div>
          </div>

          <div *ngIf="activeSteps.includes(47) && formData.towers1" class="wizard-step">
            <h3>Grow Towers/systems</h3>
            <div class="mt-3">
              <label for="towersSystemDescription">Describe your growing system:</label>
              <input id="towersSystemDescription" name="towersSystemDescription" maxlength="100"
                     [(ngModel)]="formData.towersSystemDescription" class="form-control mb-3"/>
            </div>

            <div class="mt-3">
              <label for="towersItemsGrown">Items grown:</label>
              <input id="towersItemsGrown" name="towersItemsGrown" maxlength="100"
                     [(ngModel)]="formData.towersItemsGrown" class="form-control mb-3"/>
            </div>

            <div class="mt-3">
              <label for="towersFoodDonatedLbs">Pounds of Indoor food grown donated:</label>
              <input type="number" [(ngModel)]="formData.towersFoodDonatedLbs" class="form-control mb-3"
                     id="towersFoodDonatedLbs"
                     name="towersFoodDonatedLbs" min="0" style="max-width: 5rem;"
                     #towersFoodDonatedLbs="ngModel"
                     appIntegerInput>
            </div>
          </div>

          <div *ngIf="activeSteps.includes(48) && formData.textiles1" class="wizard-step">
            <h3>Textiles</h3>
            <div class="mt-3">
              <label for="textileLbsCollected">Lbs of textiles collected for recycling (enter comment):</label>
              <input type="number" [(ngModel)]="formData.textileLbsCollected" class="form-control mb-3"
                     id="textileLbsCollected"
                     name="textileLbsCollected" min="0" style="max-width: 5rem;"
                     #textileLbsCollected="ngModel"
                     appIntegerInput>
            </div>

            <div class="mt-3">
              <label for="textileCompany">Textiles Company name (enter comment):</label>
              <input id="textileCompany" name="textileCompany" maxlength="50"
                     [(ngModel)]="formData.textileCompany" class="form-control mb-3"/>
            </div>

            <div class="mt-3">
              <label for="textileDollarsEarned">Textiles-Dollars earned (enter comment):</label>
              <input type="number" [(ngModel)]="formData.textileDollarsEarned" class="form-control mb-3"
                     id="textileDollarsEarned"
                     name="textileDollarsEarned" min="0" style="max-width: 5rem;"
                     #textileDollarsEarned="ngModel"
                     appIntegerInput>
            </div>
          </div>

          <div *ngIf="activeSteps.includes(49) && formData.plastics1" class="wizard-step">
            <h3>Plastic (bottles, etc)</h3>
            <div class="mt-3">
              <label for="plasticLbsCollected">Lbs. collected (enter comment):</label>
              <input type="number" [(ngModel)]="formData.plasticLbsCollected" class="form-control mb-3"
                     id="plasticLbsCollected"
                     name="plasticLbsCollected" min="0" style="max-width: 5rem;"
                     #plasticLbsCollected="ngModel"
                     appIntegerInput>
            </div>

            <div class="mt-3">
              <label for="plasticCollectedBy">Plastic Items donated to or collected by (enter comment):</label>
              <input id="plasticCollectedBy" name="plasticCollectedBy" maxlength="100"
                     [(ngModel)]="formData.plasticCollectedBy" class="form-control mb-3"/>
            </div>
          </div>

          <div *ngIf="activeSteps.includes(50) && formData.aluminumcans1" class="wizard-step">
            <h3>Aluminum Cans</h3>
            <div class="mt-3">
              <label for="aluminumLbsCollected">Lbs. collected (enter comment):</label>
              <input type="number" [(ngModel)]="formData.aluminumLbsCollected" class="form-control mb-3"
                     id="aluminumLbsCollected"
                     name="aluminumLbsCollected" min="0" style="max-width: 5rem;"
                     #aluminumLbsCollected="ngModel"
                     appIntegerInput>
            </div>

            <div class="mt-3">
              <label for="aluminumCollectedBy">Cans donated to or collected by (enter comment):</label>
              <input id="aluminumCollectedBy" name="aluminumCollectedBy" maxlength="100"
                     [(ngModel)]="formData.aluminumCollectedBy" class="form-control mb-3"/>
            </div>
          </div>

          <div *ngIf="activeSteps.includes(51) && formData.earthDayEvent" class="wizard-step">
            <h3>Earth Day</h3>
            <div class="mt-3">
              <label for="chipperDate">Event Date:</label>
              <input type="date" id="earthDayDate" name="earthDayDate" class="form-control mb-2"
                     [(ngModel)]="formData.earthDayDate" style="max-width: 10rem"/>
            </div>

            <div class="mt-3">
              <label for="chipperResults">Results:</label>
              <textarea id="earthDayResults" name="earthDayResults" [(ngModel)]="formData.earthDayResults"
                        maxlength="100"
                        class="form-control" placeholder="Enter results (max 100 characters)"></textarea>
            </div>
          </div>

          <div *ngIf="activeSteps.includes(52) && formData.americaRecyclesEvent" class="wizard-step">
            <h3>America Recycles day</h3>
            <div class="mt-3">
              <label for="chipperDate">Event Date:</label>
              <input type="date" id="americaRecyclesDate" name="americaRecyclesDate" class="form-control mb-2"
                     [(ngModel)]="formData.americaRecyclesDate" style="max-width: 10rem"/>
            </div>

            <div class="mt-3">
              <label for="chipperResults">Results:</label>
              <textarea id="americaRecyclesResults" name="americaRecyclesResults"
                        [(ngModel)]="formData.americaRecyclesResults"
                        maxlength="100"
                        class="form-control" placeholder="Enter results (max 100 characters)"></textarea>
            </div>
          </div>

          <div *ngIf="activeSteps.includes(53) && formData.wind1" class="wizard-step">
            <h3>Wind</h3>
            <div class="mt-3">
              <label for="windInstructionComment">Describe wind system and how used it is for instruction:</label>
              <textarea id="windInstructionComment" name="solarInstructionComment"
                        [(ngModel)]="formData.windInstructionComment" maxlength="200" class="form-control mb-2"
                        placeholder="Enter comment (max 200 characters)"></textarea>
            </div>
            <div class="mt-3">
              <label for="windUtilityComment">How is wind power utilized for school utilities?</label>
              <textarea id="windUtilityComment" name="windUtilityComment" [(ngModel)]="formData.windUtilityComment"
                        maxlength="200" class="form-control"
                        placeholder="Enter comment (max 200 characters)"></textarea>
            </div>
          </div>

          <div *ngIf="activeSteps.includes(54) && formData.water1" class="wizard-step">
            <h3>Water</h3>
            <div class="mt-3">
              <label for="solarInstructionComment">Describe water system and how it is used for instruction:</label>
              <textarea id="waterInstructionComment" name="waterInstructionComment"
                        [(ngModel)]="formData.waterInstructionComment" maxlength="200" class="form-control mb-2"
                        placeholder="Enter comment (max 200 characters)"></textarea>
            </div>
            <div class="mt-3">
              <label for="waterUtilityComment">How is water power utilized for school utilities?</label>
              <textarea id="waterUtilityComment" name="solarUtilityComment" [(ngModel)]="formData.waterUtilityComment"
                        maxlength="200" class="form-control"
                        placeholder="Enter comment (max 200 characters)"></textarea>
            </div>
          </div>

          <div *ngIf="activeSteps.includes(55) && formData.recycleOtherCheck" class="wizard-step">
            <h3>Other Recycle</h3>
            <div class="mt-3">
              <label for="otherLbsCollected">Lbs. collected (enter comment):</label>
              <input type="number" [(ngModel)]="formData.otherLbsCollected" class="form-control mb-3"
                     id="otherLbsCollected"
                     name="otherLbsCollected" min="0" style="max-width: 5rem;"
                     #otherLbsCollected="ngModel"
                     appIntegerInput>
            </div>

            <div class="mt-3">
              <label for="otherCollectedBy">Other Items donated to or collected by (enter comment):</label>
              <input id="otherCollectedBy" name="otherCollectedBy" maxlength="100"
                     [(ngModel)]="formData.otherCollectedBy" class="form-control mb-3"/>
            </div>
          </div>

          <div *ngIf="activeSteps.includes(56) && formData.recyclingEventsOtherCheck" class="wizard-step">
            <h3>Other Recycling Event</h3>
            <div class="mt-3">
              <label for="otherEventDate">Event Date:</label>
              <input type="date" [(ngModel)]="formData.recyclingEventsOtherDate" class="form-control mb-3"
                     id="otherEventDate"
                     name="otherEventDate" min="0" style="max-width: 8rem;"
                     #otherEventDate="ngModel">
            </div>

            <div class="mt-3">
              <label for="otherEventsResults">Results:</label>
              <textarea id="otherEventsResults" name="otherEventsResults" maxlength="100"
                        [(ngModel)]="formData.recyclingEventsOtherResults" class="form-control mb-3"></textarea>
            </div>
          </div>
        </form>
      </div>
      <div class="col save-submit">
        <button type="submit" [disabled]="wizardForm.invalid" (click)="submitForm()" class="btn btn-success btn-lg">Save
        </button>
        <a href="/find-projects" class="btn d-flex align-items-center" style="background-color: red; color: white">
          CANCEL
          <span class="material-symbols-outlined ms-1">close</span>
        </a>
      </div>
    </div>

  </div>


</div>

